import React from "react";
import { Text, StyleSheet, View, TouchableOpacity } from "react-native";

import ActivityColor from "../../journal/timeslots/ActivityColor";
import Icons from "../../common/icons";
import appStyles from "../../../appStyles";
import AppTheme from "../../AppTheme";

export default function SleepActivity({
  timeslot,
  onActivitySelected = () => {},
}) {
  const { activity } = timeslot;

  return (
    <TouchableOpacity
      style={[
        appStyles.timeslot,
        timeslot.isSelected && styles.selected,
        {
          height: 50,
          marginLeft: 25,
        },
      ]}
      onPress={onActivitySelected}
    >
      <Icons.SleepIcon onPress={onActivitySelected} width={20} height={20} />
      <ActivityColor color={activity.color} />
      <View style={[appStyles.flex1]}>
        <Text style={[appStyles.activityNameUndo]}>{activity.name}</Text>
      </View>
    </TouchableOpacity>
  );
}

const styles = StyleSheet.create({
  selected: {
    backgroundColor: AppTheme.DEFAULT_COLOR,
    borderRadius: 25,
  },
});
